import request from "@/utils/request";

export default function payAnnualFeeByWeChat(data) {
  return request({
    url: `/device/agent/chargingPile/payDeviceAnnualFee`,
    method: "post",
    data,
  });
}
